import styled from 'styled-components'

export const BgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
  flex-grow: 1;
  width: 83%;
  background-color: ${props => (props.darkMode ? '#0f0f0f' : '#f9f9f9')};
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 40px 10px 40px;
  width: 100%;
  background-color: ${props => (props.darkMode ? ` #181818` : '#ebebeb')};
`

export const HeaderContent = styled.h1`
  color: ${props => (props.darkMode ? '#f1f1f1' : '#0f0f0f')};
`

export const VideosListContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: ${props => (props.orientation ? 'row' : 'column')};
  flex-wrap: wrap;
`

export const IconComponent = styled.div`
  background-color: ${props => (props.darkMode ? '#0f0f0f' : '#f1f5f9')};
  color: #ff0000;
  font-size: 32px;
  margin-right: 16px;
  padding: 14px 20px 14px 20px;
  border-radius: 50px;
`
